import { tagServices } from 'src/services/reservation/tag/tag.service'
import { itemServices } from 'src/services/reservation/item/item.service'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'

export const handleCreateUpdateTag = async (
  record: any,
  cardId: string,
  setLoadingTagModal: React.Dispatch<React.SetStateAction<boolean>>,
  notify: any,
  refresh: any,
  setCardLoading: any,
  work_unit_id: number,
  modeSelect: boolean = false
) => {
  try {
    setLoadingTagModal(true)
    if (modeSelect ? record && record?.tags : record && record?.tag) {
      const { tag } = record
      let response = null
      if (modeSelect) {
        const new_tags_id = record?.tags?.map((tag: any) => String(tag.id))
        const all_tags_id = record?.tag_relation?.map((tag: any) => String(tag.id))
        response = await itemServices.add_tags_in_item(record.item_id, [
          ...(all_tags_id || []),
          ...new_tags_id,
        ])
      } else {
        response = await tagServices.createAndAssociateToitem(record.item_id, { ...tag, work_unit_id })
      }

      if (response) {
        notify('ra.notification.add_tag_success', {
          type: 'success',
        })
        return
      }
    }
    notify('ra.notification.add_tag_error', {
      type: 'error',
    })
  } catch (error) {
    console.log('error', error)

    notify('ra.notification.add_tag_error', {
      type: 'error',
    })
  } finally {
    setLoadingTagModal(false)
    setCardLoading(cardId, true)
    customAwait([refresh])
  }
}
